import {
    getClientEditBillId,
    getClientBillId,
    putClientSave,
    getBillActionList
} from "@/http/customer/customer";

export default {
    namespaced: true,
    state: {
        clientsDataEditId: {},
        clientsDataId: {},
        collectionActions: [],
    },
    actions: {
        async setClientEditId({ commit }, id) {
            const response = await getClientEditBillId(id);
            commit("SET_CLIENTS_EDIT_ID", response.data);
            return response;
        },
        async setClientId({ commit }, id) {
            const response = await getClientBillId(id);
            commit("SET_CLIENTS_ID", response.data);
            return response;
        },
        async setClientEditSave({ commit }, data) {
            const response = await putClientSave(data.id, data.data);
            return response;
        },
        async setBillActionList({ commit }, id) {
            const response = await getBillActionList(id);
            commit("SET_BILL_ACTIONS", response.data);
            return response;
        },
    },
    mutations: {
        SET_CLIENTS_EDIT_ID(state, payload) {
            state.clientsDataEditId = payload;
        },
        SET_CLIENTS_ID(state, payload) {
            state.clientsDataId = payload;
        },
        SET_BILL_ACTIONS(state, payload) {
            state.collectionActions = payload;
        },
    },
    getters: {
        getClientEditBillId(state) {
            return state.clientsDataEditId;
        },
        getClientBillId(state) {
            return state.clientsDataId;
        },

    },
};
